<template>
  <section id="app">
    <div class="banner" :style="{height: `${[100010370].includes(datas.id)?'250px':'200px'}`}">
      <img class="banner-img" :src="`/static/images/Normal20/${datas.img}.jpg`">
      <!-- <div class="logo"><img class="logo-img" src="../../images/bk/nav-logo.png" /></div> -->
    </div>
    <div class="box">
      <div class="box-main">
        <div class="head-nav">
          <a v-for="(item,index) in headNav" :class="{'head-nav-active':index == navix}" @click="NavToggle(index)">{{item}}<i></i></a>
        </div>
        <div class="main">
          <div class="main-box" v-for="(val,ix) in intr" :data-url="val.url">
            <div v-for="v in val.list">
              <p class="title" v-if="v.key" v-text="v.key"></p>
              <p class="text" v-if="v.value" v-text="v.value"></p>
            </div>
          </div>
        </div>
        <div @click="ViewNow" class="main-button">立即查看　View Now</div>
      </div>
    </div>
    <div class="subscript">
      <div class="subscript-main">
        <i class="subscript-icon subscript-left"></i>
        {{datas.name}}制药(老挝)有限公司
        <i class="subscript-icon subscript-right"></i>
      </div>
      <div class="version">{{ datas.enName }} {{datas.right}}</div>
    </div>
  </section>
</template>

<script>
var self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'qr',
  components: {
    'K-Loading': Loading,
    'K-ModelLoading': ModelLoading
  },
  data () {
    return {
      navix: 0,
      headNav: ["中文版","English"],
      dataObj: {
        100010304:{
          id: 100010304,
          img: 'nav-banner',
          name: '卢修斯',
          enName: 'Lucius',
          right: 'pharmaceuticals (Lao) Co., Ltd',
        },
        100010370:{
          id: 100010370,
          img: 'dx-nav-banner',
          name: '大熊',
          enName: 'BigBear',
          right: 'Pharmaceutical Co., Ltd',
        }
      },
      datas: {},
      intr: []
    }
  },
  created() {
    this.datas = this.dataObj[localStorage.getItem("wwmxt_Rootid") || 100010304]
    this.intr = [{
      list: [
        {
          key: '',
          value: `Released by: ${this.datas.enName} Product Traceability Anti-counterfeiting Verification System`
        },
        {
          key: '* Enquiries and Announcements',
          value: 'The product origin, packaging information, Drug registertation certificate, Analysis report, and other related product information references'
        }
      ]
    }]
  },
  methods: {
    NavToggle (ix) {
      this.navix = ix;
    },
    ViewNow () {
      if(this.navix == 0){
        localStorage.setItem("wwm_language", 'cn');
      }else{
        localStorage.setItem("wwm_language", 'en');
      }
      this.$router.push({path: "/Normal20"});
    }
  }
}
</script>

<style scoped>
.banner{
  position: relative;
  height: 200px;
  overflow: hidden;
}
.banner-img{
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.logo{
  position: absolute;
  top:0;
  height: 200px;
  left:0;right: 0;
  background: rgba(0,0,0,0.2);
}
.logo-img{
  height: 75px;
  display: table;
  margin:45px auto;
}
.box{
  position: relative;
}
.box-main{
  position: relative;
  top:-60px;
  margin:0 20px;
  padding-bottom: 20px;
  border-radius: 10px 10px 0 0;
  background-color: #FFF;
  box-shadow: 0 0 5px rgba(0,0,0,0.05);
}
.head-nav{
  overflow: hidden;
  padding:20px 25px;
}
.head-nav a{
  display: block;
  float: left;
  width: calc(50% - 15px);
  font-weight: bold;
  padding: 15px 5px;
  text-align: center;
  position: relative;
  color: #FFF;
  border-radius: 5px;
  opacity: 0.6;
  background-color: #2271ea;
}
.head-nav a:last-child{
  margin-left: 10px;
}
.head-nav-active{
  opacity: 1 !important;
}
.head-nav-active i{
  position: absolute;
  width: 50px;
  height: 2px;
  left:calc(50% - 25px);
  bottom:5px;
  border-radius: 5px;
  background-color: #FFF;
}

.main{
  padding:20px 25px;
  border-top: 1px solid #E9E9E9;
}
.text{
  font-size: 15px;
  color: #868686;
  margin-top: 5px;
}
.title{
  font-size: 15px;
  margin-top: 20px;
}
.main-button{
  padding: 12px 10px;
  background-color: #2271EA;
  text-align: center;
  color: #FFF;
  margin: 0 25px;
  margin-top: 20px;
  border-radius: 5px;
}
.subscript{
  position: fixed;
  bottom:0;left:0;
  right:0;
  padding: 15px 0;
  font-size: 13px;
  background-color: #EBEFF5;
}
.subscript-main{
  display: table;
  margin: 0 auto;
  color: #888;
		  position: relative;
		}
		.subscript-icon{
		  width: 30px;
		  height: 1px;
		  top:8px;
		  position: absolute;
		  background-color: #D3D3D3;
		}
		.subscript-left{
		  left:-38px;
		}
		.subscript-right{
		  right:-38px;
		}
		.version{
		  color: #888;
		  font-size: 11px;
		  margin-top: 5px;
		  text-align: center;
		}
</style>



// WEBPACK FOOTER //
// src/public-view/Lxs.vue